import { customSortApprovalAmount, customSortApprovedAmount, customSortPoNo, customSortPurchaseDate, customSortSpentAmount, genericSort } from "../customSort/customSort";

export const columnsDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Order Date",
    accessor: "orderdate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Receiver Name",
    accessor: "receivername",
    sortType:genericSort
  },
  {
    Header: "Approved Amount",
    accessor: "approvedAmount",
    sortType:customSortApprovedAmount
  },
  {
    Header: "Spent Amount",
    accessor: "spentAmount",
    sortType:customSortSpentAmount
  },
  {
    Header: "Invoice",
    accessor: "invoice",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

export const pendingDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Order Date",
    accessor: "orderdate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Receiver Name",
    accessor: "receivername",
    sortType:genericSort
  },

  {
    Header: "Requested Amount",
    accessor: "approvalAmount",
    sortType:customSortApprovalAmount
  },
  {
    Header: "Invoice",
    accessor: "invoice",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];
export const rejectedDataColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "Po No",
    accessor: "poNo",
    sortType:customSortPoNo
  },
  {
    Header: "Order Date",
    accessor: "orderdate",
    sortType:customSortPurchaseDate
  },
  {
    Header: "Receiver Name",
    accessor: "receivername",
    sortType:genericSort
  },
  {
    Header: "Requested Amount",
    accessor: "approvalAmount",
    sortType:customSortApprovalAmount
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];
